import type {Result, UseCase} from 'framework';
import type {Product} from '../../domain/product';
import type {ProductError} from '../../domain/errors';
import type {CreateFromCatalogInput, ProductRepository} from '../ports/product.repository';

export class CreateProductFromCatalog implements UseCase<[CreateFromCatalogInput], Product> {
  constructor(private readonly repository: ProductRepository) {}

  execute(input: CreateFromCatalogInput): Promise<Result<Product, ProductError>> {
    return this.repository.createFromCatalog(input);
  }
}
